const localValue = {
	subPlans: [],
	subPlanUpdateTimestamp: -1
}

module.exports = {
	localValue
}